// extracted by mini-css-extract-plugin
module.exports = {"startRow":"styles_startRow__1ubnp","startRight":"styles_startRight__2cDYP"};